import {FlowBase, identificationTypes} from "./flow-base";
import * as events from '../events';


class OrangeFrance extends FlowBase {
    handleIntegratorIframeIdentity() {
        //since heIframeIdentity has no error handled add a timeout then call identifyOnError
        this.iframeTimeout = window.setTimeout(() => {
            this.checkIdentify()
        }, this.identifyTimeout * 1000);

        this.integrator.customHeIframeIdentifyBaseUrl(this.identifyEndpoint,
            {
                return: window.location.origin + window.location.pathname,
                metadata: this.metadata,
            }
        );
    }

    handleOtpChallengeValidate() {
        this.logger.info(`Flow (${this.name}): handling challenge validation`);
        this.tracker.track(events.SECOND_CLICK)

        if (this.identification == identificationTypes.DEBUG) {
            this.otpValidateSuccess({"status": "SUCCESS"})
            return
        }

        if (this.uiControl.controls.otp.code.value === '') {
            this.tracker.track(events.OTP_VALIDATE_FAILURE, {data: {message: "empty_code"}})
            this.uiControl.hideElement(this.uiControl.controls.otp.error)
            this.uiControl.showElement(document.getElementById('flow-otp-error-noentry'))
            return
        }
        this.uiControl.hideElement(document.getElementById('flow-otp-error-noentry'))

        this.setFlowStep(this.flowSteps.OTP_VALIDATE)

        if (this.preSubscribe) {
            this.dispatcher.dispatchEvent(events.PRE_SUBSCRIBE);
        }

        const data = {
            plan: this.plan,
            product: this.productSlug,
            metadata: this.metadata,
            token: this.token ?? this.identity,
            code: this.uiControl.controls.otp.code.value,
            identity: this.identity,
        }

        if (this.usernameFlow) {
            data['username'] = this.chosenUsername;
        }
        data['mixpanel_tracking_id'] = typeof this.metadata['mixpanel_tracking_id'] !== 'undefined' ? this.metadata['mixpanel_tracking_id'] : this.metadata['evinaTransactionID']
        data['locale'] = this.locale;
        data['territory'] = this.territory;//Added these fields to ensure that OTP Validation is correctly configured and has all the fields that the integrator expects
        this.integrator.LPOtpSubscribeCustomRequest(data, this.otpChallengeValidateURL, this.otpValidateSuccess.bind(this), this.otpValidateError.bind(this));
    }

    //Overriden to show custom error messages
    otpValidateError(response) {
        this.uiControl.hideElement(this.uiControl.controls.spinner);
        if (response.type && response.type === "INSUFFICIENT_CREDIT") {
            this.logger.debug(`[Subscribe Error] Flow (${this.name}): insufficent funds`, {"response": response});
            this.setFlowStep(this.flowSteps.SUBSCRIPTION_FAILED);
            this.dispatcher.dispatchEvent(events.SUBSCRIPTION_FAILED, {
                reference: response.reference,
                status_code: response.status_code,
                error: this.returnErrorMessageFromResponse(response),
                response_string: response.response_string || null,
            });
            this.uiControl.showErrorMessage('INSUFFICENT_FUNDS', 'Retry');
        } else if (response.type && response.type === "INCORRECT_OTP") {
            this.logger.error(`[Subscribe Error] Flow (${this.name}): received error from integrator`, {"response": response});
            this.setFlowStep(this.flowSteps.OTP_VALIDATE_ERROR);
            this.uiControl.hideElement(this.uiControl.controls.otp.error);
            this.dispatcher.dispatchEvent(events.SUBSCRIPTION_FAILED, {
                reference: response.reference,
                status_code: response.status_code,
                error: this.returnErrorMessageFromResponse(response),
                response_string: response.response_string || null,
            });
        } else {
            this.logger.error(`[Subscribe Error] Flow (${this.name}): received error from integrator`, {"response": response});
            this.setFlowStep(this.flowSteps.SUBSCRIPTION_FAILED);
            this.dispatcher.dispatchEvent(events.SUBSCRIPTION_FAILED, {
                reference: response.reference,
                status_code: response.status_code,
                error: this.returnErrorMessageFromResponse(response),
                response_string: response.response_string || null,
            });
            this.uiControl.showErrorMessage('INTEGRATOR_ERROR', 'Retry');
        }
    }
}

const OrangeFranceFlowModule = new OrangeFrance('Orange France HE OTP', identificationTypes.IFRAME, {
    heOtp: true,
    OTP: false,
    usernameFlow: true,
    subscribeClick: true,
    inactiveTimeout: false,
    otpChallengeValidateURL: 'lp/otp/subscribe/fr',

})
window.FlowModule = OrangeFranceFlowModule;
